import React from 'react';
import Jibber from '/app/src/jibber'
import {connect} from 'react-redux';
import {Flex, SVGButton, SVG, Arrow} from '/app/src/component';

import style from './style.css'
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc'
import {FAQModel, SystemModel} from '/app/src/model'
import {FAQSelector} from '/app/src/model/selectors'
import {history} from '/app/src/store/store'
import RemoveItemModal from './RemoveItemModal'
import _ from 'lodash'

class FAQ extends Jibber{
    constructor(props){
        super(props)
        this.useState({
            'hover': false,
            'showTransfer': false,
        })
        this.ref = React.createRef()
        this.handleClick = this.handleClick.bind(this)
        this.handleOnUpdate = this.handleOnUpdate.bind(this)
    }

    componentDidMount(){
        document.addEventListener('mousedown', this.handleClick, false);
    }
    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleClick, false);
    }

    handleClick(e){
        if(this.ref && this.ref.current && this.ref.current.contains(e.target)){
            return;
        }
        this.setShowTransfer(false)
    }

    handleOnUpdate(id, update){
        this.props.updateItem(id, update);
    }

    render(){
        const props = this.props
        const {disabled, item, setOpenModal, setCurrentItem, setSelectedItem} = this.props
        const {hover, showTransfer} = this.state
        const active = props.currentItemId === item.id
        const imgPath='https://storage.googleapis.com/jibber-image/images/'
        const categoryImgStyle = {
            'width': '30px', 'fill': '#4ec1e0', 'marginRight': '10px', marginTop:'3px'
        }
        const sortedCategories = _.sortBy(props.categories, ['order']);

        const FAQMove = (
            <Flex column zIndex='3' borderRadius='30px' width='274px' backgroundColor='darkwhite' padding='7px 15px'
                position='absolute' top='70px' right='10px' hostRef={this.ref}
                fontSize='24px' color='black' height='200px' overflowY='auto'
                border='1px solid grey'>

                <Flex marginTop='5px' marginBottom='10px' shrink={0}>
                    Flytta till Kategori
                    <Flex hAlignContent='right' ml='10px'>
                        <SVGButton src='/images/ArrowDown_S.svg' color='blue' height='35px' width='35px'/>
                    </Flex>
                    </Flex>
                {_.map(sortedCategories, (c, i)=>{
                    if(props.categoryId === c.id) return;
                    return (
                        <Flex shrink={0} key={i} backgroundHover='#e5e5e5' height='40px' borderRadius='20px' px='14px' vAlignContent='center'
                            onClick={()=>this.props.updateItem(item.id, {'category_id':  c.id})}
                        >
                            <SVG  style={categoryImgStyle}cacheGetRequests={true} src={imgPath+c.imgSrc}/>
                            <Flex> <div className='ellipsis'>{c.category}</div></Flex>
                        </Flex>
                    )
                })}
            </Flex>
        )

        const wrapperBorder = (disabled && active)?'3px solid #2ea2d2': '3px solid transparent'
        const wrapperBackgroundcolor = (disabled & active)?'lightblue':'darkwhite'
        const wrapperbackgroundHover = active?'lightblue':'#f0f0f0'
        return ( <Flex w='100%' h='100%' borderRadius='60px'
                    backgroundColor={wrapperBackgroundcolor}
                    border={wrapperBorder}
                    backgroundHover={wrapperbackgroundHover}
                    cursor='pointer' vAlignContent='center' my='5px'
                    onMouseEnter={()=>{this.setHover(true)}} onMouseLeave={()=>{this.setHover(false)}}
                    onClick={()=>{
                        setCurrentItem(item.id)
                    }}
                    position='relative'
                    userSelect='none'
                >
                    {!disabled && <Flex position='absolute' h='100%' w='100%' center zIndex='1'
                          borderRadius='60px'
                          background='linear-gradient(to left, rgba(255, 255, 255, 0), #f0f0f0 49%, rgba(255, 255, 255, 0))'
                          >
                          <SVGButton
                              src='/images/ChangeOrder_M.svg' color='darkgrey'
                              width='90px' height='90px'/>
                      </Flex>
                    }
                    <Flex grow fontSize='26px' color='black' px='15px' ml='15px'>
                        <div className='ellipsis'>{item.question}</div>
                    </Flex>


                <Flex shrink={0} px='20px' right='0' h='100%'
                    borderRadius='0 60px 60px 0' w='232px'>
                    {(disabled &&(active || hover)) ?
                    <React.Fragment>
                        <SVGButton src='/images/Trash.svg' color='darkgrey' hover='red'
                        onClick={()=>{
                            setOpenModal(true)
                            setCurrentItem(item)
                            setSelectedItem(item)
                        }}/>
                    <SVGButton src='/images/MoveToCategory_S.svg' color='darkgrey' hover='blue' onClick={()=>{this.setShowTransfer(true)}} title='Flytta till Kategori'/>
                         {active && showTransfer && FAQMove}
                        <SVGButton src='/images/Edit_M.svg' color='darkgrey' hover='blue'
                            onClick={(e)=>{
                                e.stopPropagation();
                                history.push('/clientChat/faq/helpdesk/category/'+props.categoryId+'/update/'+item.id);
                                setCurrentItem(item.id);
                                }
                            }
                        />
                        <SVGButton color='darkgrey' hover='blue'
                            onClick={()=>this.handleOnUpdate(item.id, {'visible': !item.visible})}
                            src={item.visible?'/images/Visible.svg':'/images/Hidden.svg'}
                        />
                    </React.Fragment>
                    :
                    <SVGButton hover='blue' ml='auto'
                        src={item.visible?'/images/Visible.svg':'/images/Hidden.svg'}
                        color={item.visible?'blue':'grey'}
                        onClick={()=> this.handleOnUpdate(item.id, {'visible': !item.visible})}
                    />
                    }
                </Flex>
            </Flex>
    )}


}

class CategoryMain extends Jibber{
    constructor(props){
        super(props)
        let items =_.sortBy(props.items, ['order'])
        this.useState({
            'isEdit': false,
            'items': items,
            'dirty': {},
            'openModal': false,
            'selectedItem': null,
        })
        this.onSortEnd = this.onSortEnd.bind(this)
    }
    onSortEnd({oldIndex, newIndex}){
        let newSortedLists = arrayMove(this.state.items, oldIndex, newIndex)

        let dirty = this.state.dirty
        for(var index in newSortedLists){
            let item = newSortedLists[index]
            if(parseInt(item.order, 10) !== parseInt(index, 10)) {
                newSortedLists[index].order = index
                dirty[item.id] = true
            }
        }
        this.setItems(newSortedLists)
        this.setDirty(dirty)
    }

    componentDidMount(){
        //If user reloads the page, we will have to fetch categories again
        if(this.props.categories.length === 0){
            this.props.dispatchGetCategories()
        }
        this.props.readItems(this.props.categoryId)
        let items =_.sortBy(this.props.items, ['order'])
        this.setItems(items)
    }

    componentDidUpdate(prevProps, prevState){
        if(prevProps.items!== this.props.items){
            const items= _.sortBy(this.props.items, ['order'])
            this.setItems(items)
        }
    }

    render(){
        const disabled = !this.state.isEdit
        const {categories} = this.props;

        const SortableItem = SortableElement(({item}) => {
            return (
                <li className={style.FAQItem}>
                    <FAQ item={item} setOpenModal={this.setOpenModal}
                        categories={categories}
                        categoryId={this.props.categoryId} currentItemId={this.props.currentItemId}
                        updateItem={this.props.updateItem} disabled={disabled}
                        setSelectedItem={(item) => this.setSelectedItem(item)}
                        setCurrentPayload={this.props.setCurrentPayload}
                        setCurrentItem={(currentId) =>{
                            if(this.props.rightMenuIsToogle){
                                this.props.toogleRightMenu(false)
                            }
                            if(this.props.currentItemId !== item.id){
                                this.props.setCurrentItem(currentId)
                            }

                        }}/>
                </li>
            )
        })
        const SortableList = SortableContainer(({items}) => {
            return (
                <ul className={style.FAQList}>
                  {items.map((item, index) => {
                       return  <SortableItem index={parseInt(item.order, 10)} key={`item-${item.id}`} item={item} disabled={disabled}/>
                  })}
                </ul>
              )
        });

        const FAQHelpdeskCategoryContainerStyle = {
            dataName: 'HelpdeskCategoryContainer',
            hAlignContent: 'center',
            column: true,
            w: '100%'
        }
        const CategoryContainerHeaderStyle= {
            dataName: 'CategoryContainerHeader',
            height: '70px',
            width: '100%',
            color: 'grey',
            fontSize: '26px',
            fontWeight: '500',
            vAlignContent: 'center',
            background: 'white',
            shrink: 0,
        }

        const BackArrowButtonStyle = {
            dataName: 'ContainerHeaderBackArrow',
            direction: 'left',
            color: 'grey',
            hover: 'blue',
        }
        const BackArrowButtonProps= {
            text: 'Tillbaka till Kategorier',
            onClick: (e)=>{
                e.stopPropagation();
                history.push('/clientChat/faq/helpdesk/categories/')
            },
        }

        const HeaderCancelButtonStyle = {
            dataName: 'HeaderCancelButton',
            border: true,
            color: 'black',
            hover: 'blue',
            borderRadius: '30px',
            pl: '20px',
            pr: '10px',
            fontSize: '21px',
            backgroundColor: 'white'
        }
        const HeaderCancelButtonProps = {
            onClick: (e)=>{
                        e.stopPropagation()
                        this.setItems(this.props.items)
                        this.setIsEdit(false)
            },
            text: 'Avbryt',
            src:'/images/Return.svg',
        }

        const HeaderChangeOrderButton = {
            text: 'Ändra ordning',
            src: '/images/ChangeOrder_M.svg',
            onClick: (e)=>{
                e.stopPropagation()
                this.setIsEdit(true)
            },

            color: 'black', hover: 'blue',
            borderRadius: '30px',
            pl: '20px', pr: '10px', mr: '20px',
            border: true,
            fontSize: '21px',
            backgroundColor: 'white'
        }
        const HeaderSaveOrderButton= {
             onClick: (e) => {
                e.stopPropagation()
                var payload = []
                _.forEach(this.state.dirty, (value, itemId) => {
                    const item = _.find(this.state.items, (c)=>{
                        return c.id === parseInt(itemId, 10)
                    })
                    if(item){
                        payload.push({
                            'id': item.id,
                            'updates': {
                                'order': item.order
                            }
                        })
                    }
                })
                if(payload.length){
                    this.props.updateItems(payload)
                }
                this.setIsEdit(false)
            },
            text: 'Spara ordning',
            src: '/images/Save.svg',
            border : true,

            color: 'black',
            hover: 'blue',
            borderRadius: '30px',
            pl: '20px', pr: '10px', mr: '20px',
            fontSize: '21px',
            backgroundColor: 'white',
        }
        const CreateButton = {
            onClick: (e)=>{
                e.stopPropagation();
                setCurrentItem(0);
                history.push('/clientChat/faq/helpdesk/category/'+this.props.categoryId+'/create')
            },
            backgroundColor: 'darkwhite', backgroundHover: 'lightblue',
            border: '3px solid transparent', hoverBorder: '3px solid #2ea2d2',
            color: 'grey',
            fontSize: '26px',
            fontWeight: '500',
            center: true,
            w: '100%',
            marginLeft: '15px',
            marginRight: '15px',
            cursor: 'pointer',
            height: '90px',
            borderRadius: '60px',
        }
        return (
            <Flex {...FAQHelpdeskCategoryContainerStyle}>
                <Flex {...CategoryContainerHeaderStyle}>
                    <Arrow {...BackArrowButtonStyle} {...BackArrowButtonProps}/>
                    <Flex ml='auto'>
                        {this.state.isEdit ?
                            <React.Fragment>
                                <SVGButton {...HeaderCancelButtonStyle} {...HeaderCancelButtonProps}/>
                                <SVGButton {...HeaderSaveOrderButton}/>
                            </React.Fragment>
                            :
                            <SVGButton {...HeaderChangeOrderButton}/>
                        }
                    </Flex>
                </Flex>
                <Flex overflowY='auto' hAlignContent='center' column w='100%' grow overflowX='hidden'>
                    <Flex {...CreateButton}> + Lägg till fråga </Flex>
                    <SortableList items={this.state.items} onSortEnd={this.onSortEnd} axis='xy' distance={5}/>
                    <RemoveItemModal open={this.state.openModal} onClose={() => {this.setOpenModal(false)}} item={this.state.selectedItem}/>
                </Flex>
            </Flex>
        )
    }
}

// TODO Only get preview instead of get all the items inc answer here.
const {dispatcher: dispatchGetCategories} = FAQModel.getCategoriesRequest()
const {selector: categoryItemSelector, dispatcher: categoryItemRead} = FAQModel.readItemsByCategoryRequest()
const {dispatcher: itemsUpdate} = FAQModel.updateItemsRequest()
const {dispatcher: itemUpdate} = FAQModel.updateItemRequest()
const {selector: currentItemSelector, dispatcher: setCurrentItem} = FAQModel.setCurrentItem()
const {selector: rightMenuToogleSelector, dispatcher: setRightMenuToogle} = SystemModel.toogleRightMenu()

const mapDispatchToProps = (dispatch, props) => {
    return {
        'navigateTo': (to)=>dispatch(SystemModel.navigateTo(to)),
        'dispatchGetCategories': ()=>dispatch(dispatchGetCategories()),
        'readItems': (categoryId)=>dispatch(categoryItemRead(categoryId)),
        'updateItems': (items)=>dispatch(itemsUpdate(items)),
        'setCurrentItem': (id)=>dispatch(setCurrentItem(id)),
        'updateItem': (faqId, updates)=>dispatch(itemUpdate(faqId, updates)),
        'toogleRightMenu': (toogle)=> dispatch(setRightMenuToogle(toogle))
    }
}

function mapStateToProps(state, props){
    let categoryId = parseInt(props.match.params.id, 10)
    let currentItemId = currentItemSelector(state)['current']
    let items = Object.values(FAQSelector.getFAQByCategoriesId(state, categoryId).toJS())
    let categories = FAQSelector.getCategories(state).toJS()
    let network = categoryItemSelector(state)['network']
    let rightMenuIsToogle = rightMenuToogleSelector(state)['toogle']

    return {
        categoryId, items, network,  categories, currentItemId, rightMenuIsToogle
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CategoryMain)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Helpdesk/Category/index.js